import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { styled } from '@mui/system';
import { isMobileMedia } from 'bento-ordering/utils/media';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import { StyledTypographyColorSectionNavLinkMainMedium } from 'components/StyledTypographyColorSectionNavLinkMainMedium';

const StyledLink = styled(Link, {
  shouldForwardProp: muiPropForwarding('isMobileMedia')
})(({ theme, isMobileMedia }) => {
  return {
    color: theme.palette.sectionNav.link.main,
    fontWeight: theme.fonts.regular,
    fontSize: '16px',
    textDecoration: 'none',
    width: 'auto',
    maxWidth: isMobileMedia ? '160px' : '200px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    '&:hover': {
      textDecoration: 'none'
    }
  };
});

function FulfillmentInformation({
  title,
  info,
  onClick = null,
  dataTestId,
  sx = {},
  disabled = false
}) {
  const titleStyles = { variant: ITEM_DESCRIPTION_AND_PRICES };
  const styles = { variant: ITEM_DESCRIPTION_AND_PRICES };
  return (
    <Box sx={{ display: 'inline-block', marginTop: '8px' }}>
      <StyledTypographyColorSectionNavLinkMainMedium
        sx={{ display: 'block' }}
        {...titleStyles}
      >
        {title}
      </StyledTypographyColorSectionNavLinkMainMedium>
      {onClick ? (
        <StyledLink
          sx={sx}
          isMobileMedia={isMobileMedia()}
          tabindex="-1"
          component="button"
          data-testid={dataTestId}
          onClick={onClick}
          {...styles}
          disabled={disabled}
        >
          {info}
        </StyledLink>
      ) : (
        <Typography {...styles}>{info}</Typography>
      )}
    </Box>
  );
}

FulfillmentInformation.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  disabled: PropTypes.bool
};

export default FulfillmentInformation;
